import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the StockCogsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-cogs',
  templateUrl: 'stock-cogs.html',
})
export class StockCogsPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  cogs = 0;
  total_initial = 0;
  total_final = 0;
  total_purchase = 0;
  no_data = true
  date_no_data = '';
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'NAME', name: this.translate.instant('general-nombre') },
    { prop: 'QUANTITY', name: this.translate.instant('general-stock-inicial') },
    { prop: 'STOCK_PURCHASE', name: this.translate.instant('general-stock-comprado') },
    { prop: 'STOCK_FINAL', name: this.translate.instant('general-stock-final') },
    { prop: 'COGS', name: this.translate.instant('general-stocl-cogs') },
    { prop: 'PRICE_COGS', name: this.translate.instant('general-total-cogs') + ' (' + this.globals.currency_symbol + ')' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController) {
    this.checkDateBeforeGet();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.checkDateBeforeGet();
      }
    });
    profileModal.present();
  }

  checkDateBeforeGet() {
    if (this.advancedAnalyticsServices.date2 >= moment().format('YYYY-MM-DDTHH:mm:ss')) {
      this.advancedAnalyticsServices.date2 = moment().subtract(1, 'day').endOf('day').format('YYYY-MM-DDTHH:mm:ss');
      //msg
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-fecha-final-no-anterior-fecha-actual'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
    this.getAnalyticsData();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date_1', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date_1', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('first_date_2', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date_2', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/stock_cogs', params, {})
      .subscribe(async response => {
        //totals
        this.no_data = response['no_data'];
        this.date_no_data = response['date_no_data'];
        this.cogs = response['cogs'];
        this.total_initial = response['total_initial'];
        this.total_final = response['total_final'];
        this.total_purchase = response['total_purchase'];
        //list
        this.rows = response['list'];
        this.temp = response['list'];
        //
        this.chartCheck = true;//boolean check
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.NAME.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const params = new HttpParams()
      .set('data', JSON.stringify(this.rows))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({}));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/stock-cogs/stock-cogs.ts